module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fb-Hc-Id-Ja.922bca6d.png";